const s = {
  sm: "3xs",
  md: "2xs",
  lg: "xs"
}, E = {
  sm: 4,
  md: 8,
  lg: 12
};
export {
  s as FOOTER_BUTTON_SIZE,
  E as FOOTER_SPACE_SIZE
};
